export function setTitle(title, sep) {
    sep = sep || ' - ';
    const pos = document.title.indexOf(sep);
    if (pos === -1) {
        document.title = title + sep + document.title;
    } else {
        document.title = title + sep + document.title.substring(pos + sep.length);
    }
}

function intToHexString(int) {
    let h = Math.round(int).toString(16);
    return h.length === 1 ? '0' + h : h;
}

function hslToRGB(h, s, l) {
    h /= 360;
    s /= 100;
    l /= 100;

    let r, g, b;
    if(s === 0){
        r = g = b = l;
    } else {
        let hue2rgb = function hue2rgb(p, q, t){
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if(t < 1/6) return p + (q - p) * 6 * t;
            if(t < 1/2) return q;
            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        };

        let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        let p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }
    return `#${intToHexString(r * 255)}${intToHexString(g * 255)}${intToHexString(b* 255)}`;
}

function getHueFromScore(score, min, max) {
    if (min < max) {
        score = score > max ? max : score;
        score = score < min ? min : score;
    }
    let norm = (score - min) / (max - min);
    return ((1 - norm) * 130).toString(10);
}

export function getColourFromScore(score, min, max) {
    //let hue = getHueFromScore(score, min, max);
    //return hslToRGB(hue, 90, 50);
    if (min < max) {
        score = score > max ? max : score;
        score = score < min ? min : score;
    }
    let norm = (score - min) / (max - min);
    return hslToRGB(0, 100, 100 - (norm * 50));
}